import ApiHelper from "@/helpers/ApiHelper";

/**
 * Base requests
 *
 * @param {ApiHelper} api
 */
export default class BaseRequests {
    baseUrl = '/some-sample-base-url';

    constructor() {
        this.api = new ApiHelper();
    }


    responseIsSuccessful(response) {
        return response.status.toString().startsWith('20') &&
            response.data &&
            response.data.success === true;
    }


    processResponse(response, errorHandler) {
        if (this.responseIsSuccessful(response)) {
            return response.data.data;
        } else {
            if (errorHandler) {
                errorHandler(response);
            }
        }

        return false;
    }


    updateApiInstance(api) {
        this.api = api;
    }
}
